import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import { modalsToggle } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';
import ChargeBuyerModal from 'components/ChargeBuyerModal';
import { useViewedVehicle } from '../../../../../hooks/useViewedVehicle';
import { useApproveHighBidMutation } from '../../../../../../../../services/api/vehicle-actions';
import { ActionDivider } from '../../../../UI';

const modalTitle = 'confirmApproveModal';
const chargeModalTitle = 'acceptHighBidCharge';

const StyledGrid = styled(Grid)`
  padding-right: 32px;
  font-size: 14px;
`;

const StyledSpanTitle = styled.span`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #212121;
  max-width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Button = styled.div`
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 20px;

  background: #3994de;

  & > span {
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    color: #fff;
  }
`;

const StyledGraySpan = styled.span`
  color: #616161;
`;

export const AcceptHighestBid = () => {
  const currentVehicle = useViewedVehicle();
  const dispatch = useDispatch();

  const [approveHighestBid] = useApproveHighBidMutation();

  if (!currentVehicle) return null;

  const highestBid = currentVehicle.highest_bid;

  const openApproveModal = () => {
    dispatch(modalsToggle(modalTitle));
  };

  const handleApprove = () => {
    dispatch(modalsToggle(modalTitle));
    dispatch(modalsToggle(chargeModalTitle));
  };

  return (
    <Fragment>
      <Grid container item xs={12}>
        <StyledGrid item xs={12} sm={8}>
          <StyledSpanTitle>Seller Accepted</StyledSpanTitle>
          <span>{`${currentVehicle.user.dealership_name}`}</span>
          <StyledGraySpan> has accepted the highest bid of </StyledGraySpan>
          <NumberFormat value={highestBid.amount} displayType="text" thousandSeparator prefix="$" />
          <StyledGraySpan> from </StyledGraySpan>
          <span>{` ${highestBid.bidder.dealership_name}`}</span>
        </StyledGrid>
        <Grid item xs={12} sm={4}>
          <Button onClick={openApproveModal}>
            <span>Approve</span>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <ActionDivider />
        </Grid>
      </Grid>
      <ConfirmModal
        submitText={'Submit'}
        modalId={modalTitle}
        title={
          <>
            You are about to approve the high bid of{' '}
            <NumberFormat displayType="text" prefix="$" value={highestBid.amount} thousandSeparator /> from{' '}
            {highestBid.bidder.dealership_name}.
          </>
        }
        handleSubmit={handleApprove}
      />
      {(currentVehicle.bids.length || currentVehicle.vehicle_price) && (
        <ChargeBuyerModal
          modalId={chargeModalTitle}
          vehicle={currentVehicle}
          chargeAction={(data: any) => approveHighestBid({ vehicleId: currentVehicle.id, data })}
        />
      )}
    </Fragment>
  );
};
